import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { font } from '../pages/Orders/Roboto-Regular-font';

// --- YARDIMCI FONKSİYONLAR ---
export const safeString = (value, fallback = '-') => (value === null || typeof value === 'undefined' || value === '') ? fallback : String(value).trim();
export const safeNumber = (value, fallback = 0) => (typeof value !== 'number' || isNaN(value)) ? fallback : value;

// Filename generation with customer name, order number, and date
export const generateOrderFilename = (order, fileType = 'pdf', prefix = 'Siparis') => {
    // Clean and shorten customer name
    let customerName = (order.customerName || 'Musteri')
        .replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ0-9\s]/g, '') // Remove special characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .substring(0, 20); // Limit to 20 characters

    // Get order number (first 6 characters)
    const orderNumber = order.id ? order.id.substring(0, 6).toUpperCase() : 'XXXXXX';

    // Format date
    const orderDate = order.orderDate?.seconds
        ? new Date(order.orderDate.seconds * 1000).toLocaleDateString('tr-TR').replace(/\./g, '-')
        : new Date().toLocaleDateString('tr-TR').replace(/\./g, '-');

    return `${customerName}-${orderNumber}-${orderDate}.${fileType}`;
};

export const imageToDataUrl = (url) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
            const reader = new FileReader();
            reader.onloadend = function () {
                resolve(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.onerror = reject;
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    });
};

// --- PDF OLUŞTURMA FONKSİYONLARI ---

export const generateOrderPDF = async (companyInfo, order, products, withImages = true, withPrices = true, withStock = false, save = true) => {
    try {
        const getProduct = (productId) => products.find(p => p.id === productId);
        const doc = new jsPDF();
        doc.addFileToVFS('Roboto-Regular.ttf', font);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');
        const pdfSettings = companyInfo?.pdfSettings || {};
        const logoUrl = companyInfo?.logoUrl || pdfSettings.logoUrl;

        if (logoUrl) {
            try {
                const logoData = await imageToDataUrl(logoUrl);
                // Adjust logo positioning and size
                doc.addImage(logoData, 'JPEG', 14, 12, 35, 15);
            } catch (e) {
                console.error("Logo yüklenemedi, firma adı kullanılacak:", e);
                doc.setFontSize(22);
                doc.setTextColor(44, 62, 80);
                doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 22);
            }
        } else {
            doc.setFontSize(22);
            doc.setTextColor(44, 62, 80);
            doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 22);
        }
        doc.setFontSize(18);
        doc.setTextColor(52, 73, 94);
        doc.text("SİPARİŞ FORMU", 200, 22, { align: 'right' });
        doc.setDrawColor(226, 232, 240);
        doc.line(14, 28, 200, 28);


        doc.setFontSize(10);
        doc.text("Firma Bilgileri", 14, 40);
        doc.setFontSize(9);
        doc.text(safeString(companyInfo?.address), 14, 46);
        doc.text(`Tel: ${safeString(companyInfo?.phone)}`, 14, 52);
        doc.text(`VD: ${safeString(companyInfo?.taxOffice)} / ${safeString(companyInfo?.taxNumber)}`, 14, 58);

        doc.setFontSize(10);
        doc.text("Müşteri Bilgileri", 120, 40);
        doc.setFontSize(9);
        doc.text(safeString(order.customerName), 120, 46);
        if (order.customerAddress) {
            doc.text(safeString(order.customerAddress), 120, 52);
        }
        if (order.customerPhone) {
            doc.text(`Tel: ${safeString(order.customerPhone)}`, 120, 58);
        }
        if (order.customerEmail) {
            doc.text(`E-posta: ${safeString(order.customerEmail)}`, 120, 64);
        }

        doc.setFontSize(10);
        doc.text("Sipariş No:", 200, 40, { align: 'right' });
        doc.setFontSize(9);
        doc.text(order.id ? order.id.substring(0, 8).toUpperCase() : '-', 200, 46, { align: 'right' });
        doc.setFontSize(10);
        doc.text("Tarih:", 200, 52, { align: 'right' });
        doc.setFontSize(9);
        const orderDate = order.orderDate?.seconds ? new Date(order.orderDate.seconds * 1000).toLocaleDateString() : (order.orderDate instanceof Date ? order.orderDate.toLocaleDateString() : 'Tarih Yok');
        doc.text(orderDate, 200, 58, { align: 'right' });

        // Tablo başlıkları ve satırları
        let tableColumn;
        if (withPrices) {
            tableColumn = withImages
                ? ["Görsel", "Barkod", "Ürün Adı", "Miktar", "Stok", "Birim Fiyat", "Toplam Tutar"]
                : ["Barkod", "Ürün Adı", "Miktar", "Stok", "Birim Fiyat", "Toplam Tutar"];

            if (!withStock) {
                tableColumn = tableColumn.filter(c => c !== "Stok");
            }
        } else {
            tableColumn = withImages
                ? ["Görsel", "Barkod", "Ürün Adı", "Miktar", "Stok"]
                : ["Barkod", "Ürün Adı", "Miktar", "Stok"];

            if (!withStock) {
                tableColumn = tableColumn.filter(c => c !== "Stok");
            }
        }

        const tableRows = await Promise.all(order.lineItems.map(async item => {
            const product = getProduct(item.productId);
            let imageData = null;
            if (withImages && product && product.imageUrl) {
                try { imageData = await imageToDataUrl(product.imageUrl); } catch (e) { console.error("Resim yüklenemedi:", e); }
            }
            const productBarcode = product?.barcode || '-';
            const productStock = product?.quantity || 0;

            let rowData = [];
            if (withImages) rowData.push(imageData ? { image: imageData, width: 15, height: 15 } : '');
            rowData.push(productBarcode);
            rowData.push(product ? product.name : 'Bilinmeyen Ürün');
            rowData.push(safeString(item.quantity));
            if (withStock) rowData.push(safeString(productStock));
            if (withPrices) {
                rowData.push(`${safeNumber(item.price).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`);
                rowData.push(`${safeNumber(item.total).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`);
            }
            return rowData;
        }));

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 75,
            theme: 'striped',
            headStyles: { fillColor: [44, 62, 80] },
            styles: { font: 'Roboto', fontStyle: 'normal' },
            columnStyles: withImages ? { 0: { cellWidth: 20, minCellHeight: 20 }, 1: { cellWidth: 25 } } : { 0: { cellWidth: 25 } },
            didDrawCell: (data) => {
                if (withImages && data.column.index === 0 && data.cell.section === 'body' && data.cell.raw?.image) {
                    const img = data.cell.raw.image;
                    const imgProps = doc.getImageProperties(img);
                    const imgWidth = 15;
                    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
                    const x = data.cell.x + (data.cell.width - imgWidth) / 2;
                    const y = data.cell.y + (data.cell.height - imgHeight) / 2;
                    doc.addImage(img, 'JPEG', x, y, imgWidth, imgHeight);
                }
            }
        });
        let finalY = doc.lastAutoTable.finalY || 75;

        if (finalY > 240) {
            doc.addPage();
            finalY = 20;
        }

        if (withPrices) {
            doc.setTextColor(73, 80, 87);
            doc.setFontSize(12);
            doc.text(`Ara Toplam:`, 160, finalY + 15, { align: 'right' });
            doc.text(`${safeNumber(order.subTotal).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`, 200, finalY + 15, { align: 'right' });
            doc.text(`KDV (%${(safeNumber(order.vatRate, 0.0) * 100).toFixed(0)}):`, 160, finalY + 22, { align: 'right' });
            doc.text(`${safeNumber(order.vatAmount).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`, 200, finalY + 22, { align: 'right' });
            doc.text(`Kargo Ücreti:`, 160, finalY + 29, { align: 'right' });
            doc.text(`${safeNumber(order.shippingCost).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`, 200, finalY + 29, { align: 'right' });
            doc.setFontSize(12);
            doc.setFont('Roboto', 'normal');
            doc.text(`Genel Toplam:`, 160, finalY + 37, { align: 'right' });
            doc.text(`${safeNumber(order.total).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`, 200, finalY + 37, { align: 'right' });
        }

        const totalQuantity = order.lineItems.reduce((sum, item) => sum + safeNumber(item.quantity), 0);
        doc.setFontSize(10);
        doc.setFont('Roboto', 'normal');
        doc.text(`Toplam Ürün Miktarı: ${totalQuantity}`, 14, finalY + 15);

        if (save) {
            const filenamePrefix = withPrices ? 'Siparis' : 'Fiyatsiz-Siparis';
            doc.save(generateOrderFilename(order, 'pdf', filenamePrefix));
        }

        return doc;
    } catch (error) {
        console.error("Sipariş PDF oluşturulurken hata:", error);
        throw error;
    }
};

// Generate filename for shipment documents
export const generateShipmentFilename = (order, shipment, fileType = 'pdf') => {
    // Clean and shorten customer name
    let customerName = (order.customerName || 'Musteri')
        .replace(/[^a-zA-ZğüşıöçĞÜŞİÖÇ0-9\s]/g, '')
        .replace(/\s+/g, '-')
        .substring(0, 20);

    const orderNumber = order.id ? order.id.substring(0, 6).toUpperCase() : 'XXXXXX';
    const shipmentId = shipment.id ? shipment.id.substring(0, 6).toUpperCase() : 'XXXXXX';

    const shipmentDate = shipment.shipmentDate?.seconds
        ? new Date(shipment.shipmentDate.seconds * 1000).toLocaleDateString('tr-TR').replace(/\./g, '-')
        : new Date().toLocaleDateString('tr-TR').replace(/\./g, '-');

    return `${customerName}-Irsaliye-${orderNumber}-${shipmentId}-${shipmentDate}.${fileType}`;
};

export const generateShipmentPDF = async (companyInfo, order, shipment, products) => {
    try {
        const getProduct = (productId) => products.find(p => p.id === productId);
        const doc = new jsPDF();
        doc.addFileToVFS('Roboto-Regular.ttf', font);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');

        const logoUrl = companyInfo?.logoUrl || companyInfo?.pdfSettings?.logoUrl;

        if (logoUrl) {
            try {
                const logoData = await imageToDataUrl(logoUrl);
                doc.addImage(logoData, 'JPEG', 14, 12, 35, 15);
            } catch (e) {
                doc.setFontSize(22);
                doc.setTextColor(44, 62, 80);
                doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 22);
            }
        } else {
            doc.setFontSize(22);
            doc.setTextColor(44, 62, 80);
            doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 22);
        }

        doc.setFontSize(18);
        doc.setTextColor(52, 73, 94);
        doc.text("SEVK İRSALİYESİ", 200, 22, { align: 'right' });
        doc.setDrawColor(226, 232, 240);
        doc.line(14, 28, 200, 28);


        doc.setFontSize(10);
        doc.text("Firma Bilgileri", 14, 40);
        doc.setFontSize(9);
        doc.text(safeString(companyInfo?.address), 14, 46);
        doc.text(`Tel: ${safeString(companyInfo?.phone)}`, 14, 52);
        doc.text(`VD: ${safeString(companyInfo?.taxOffice)} / ${safeString(companyInfo?.taxNumber)}`, 14, 58);

        doc.setFontSize(10);
        doc.text("Müşteri Bilgileri", 120, 40);
        doc.setFontSize(9);
        doc.text(safeString(order.customerName), 120, 46);
        if (order.customerAddress) {
            doc.text(safeString(order.customerAddress), 120, 52);
        }

        doc.setFontSize(10);
        doc.text("İrsaliye No:", 200, 40, { align: 'right' });
        doc.setFontSize(9);
        doc.text(shipment.id.substring(0, 8).toUpperCase(), 200, 46, { align: 'right' });
        doc.setFontSize(10);
        doc.text("Tarih:", 200, 52, { align: 'right' });
        doc.setFontSize(9);
        const shipmentDate = shipment.shipmentDate?.seconds ? new Date(shipment.shipmentDate.seconds * 1000).toLocaleDateString() : 'Tarih Yok';
        doc.text(shipmentDate, 200, 58, { align: 'right' });

        const tableColumn = ["Stok Kodu", "Ürün Adı", "Miktar", "Birim Fiyat", "Toplam Tutar"];
        const tableRows = [];
        let subTotal = 0;

        (shipment.items || []).forEach(item => {
            const product = getProduct(item.productId);
            const productBarcode = product?.barcode || '-';
            const itemTotal = safeNumber(item.price) * safeNumber(item.quantity);
            subTotal += itemTotal;
            const itemData = [
                productBarcode,
                safeString(item.name),
                safeString(item.quantity),
                `${safeNumber(item.price).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`,
                `${itemTotal.toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`,
            ];
            tableRows.push(itemData);
        });

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 75,
            theme: 'striped',
            headStyles: { fillColor: [44, 62, 80] },
            styles: { font: 'Roboto', fontStyle: 'normal' },
        });

        let finalY = (doc.lastAutoTable.finalY || 75) + 10;
        
        if (finalY > 250) {
            doc.addPage();
            finalY = 20;
        }

        doc.setFontSize(10);
        doc.setTextColor(73, 80, 87);

        doc.text(`Kargo Firması: ${safeString(shipment.cargoCompany)}`, 14, finalY + 15);
        doc.text(`Takip No: ${safeString(shipment.trackingNumber)}`, 14, finalY + 21);

        doc.setFontSize(11);
        doc.setTextColor(44, 62, 80);
        doc.text(`Toplam Tutar:`, 160, finalY + 15, { align: 'right' });
        doc.setFontSize(12);
        doc.setFont('Roboto', 'normal');
        doc.text(`${subTotal.toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`, 200, finalY + 15, { align: 'right' });

        doc.save(generateShipmentFilename(order, shipment, 'pdf'));
    } catch (error) {
        console.error("İrsaliye PDF oluşturulurken hata:", error);
        throw error;
    }
};

export const generateCombinedShipmentsPDF = async (companyInfo, order, selectedShipments, products) => {
    try {
        const getProduct = (productId) => products?.find(p => p.id === productId);
        const doc = new jsPDF();
        doc.addFileToVFS('Roboto-Regular.ttf', font);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');
        let currentY = 20;
        let isFirstShipment = true;

        for (let i = 0; i < selectedShipments.length; i++) {
            const shipment = selectedShipments[i];

            if (!isFirstShipment) {
                doc.addPage();
                currentY = 20;
            }
            isFirstShipment = false;

            doc.setFontSize(22);
            doc.setTextColor(73, 80, 87);
            doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, currentY);
            doc.setFontSize(18);
            doc.setTextColor(149, 165, 166);
            doc.text("SEVK İRSALİYESİ", 200, currentY, { align: 'right' });
            currentY += 8;
            doc.line(14, currentY, 200, currentY);
            currentY += 12;

            doc.setFontSize(10);
            doc.text("Firma Bilgileri", 14, currentY);
            doc.setFontSize(9);
            doc.text(safeString(companyInfo?.address), 14, currentY + 6);
            doc.text(`Tel: ${safeString(companyInfo?.phone)}`, 14, currentY + 12);
            doc.text(`VD: ${safeString(companyInfo?.taxOffice)} / ${safeString(companyInfo?.taxNumber)}`, 14, currentY + 18);

            doc.setFontSize(10);
            doc.text("Müşteri Bilgileri", 120, currentY);
            doc.setFontSize(9);
            doc.text(safeString(order.customerName), 120, currentY + 6);

            doc.setFontSize(10);
            doc.text("İrsaliye No:", 200, currentY, { align: 'right' });
            doc.setFontSize(9);
            doc.text(shipment.id.substring(0, 8).toUpperCase(), 200, currentY + 6, { align: 'right' });
            doc.setFontSize(10);
            doc.text("Tarih:", 200, currentY + 12, { align: 'right' });
            doc.setFontSize(9);
            const shipmentDate = shipment.shipmentDate?.seconds ? new Date(shipment.shipmentDate.seconds * 1000).toLocaleDateString() : 'Tarih Yok';
            doc.text(shipmentDate, 200, currentY + 18, { align: 'right' });

            currentY += 35;

            const tableColumn = ["Stok Kodu", "Ürün Adı", "Miktar", "Birim Fiyat", "Toplam Tutar"];
            const tableRows = [];
            let subTotal = 0;

            (shipment.items || []).forEach(item => {
                const product = getProduct(item.productId);
                const productBarcode = product?.barcode || '-';
                const itemTotal = safeNumber(item.price) * safeNumber(item.quantity);
                subTotal += itemTotal;
                const itemData = [
                    productBarcode,
                    safeString(item.name),
                    safeString(item.quantity),
                    `${safeNumber(item.price).toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`,
                    `${itemTotal.toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`,
                ];
                tableRows.push(itemData);
            });

            autoTable(doc, {
                head: [tableColumn],
                body: tableRows,
                startY: currentY,
                theme: 'striped',
                headStyles: { fillColor: [44, 62, 80] },
                styles: { font: 'Roboto', fontStyle: 'normal' },
            });
            let finalY = (doc.lastAutoTable.finalY || currentY) + 10;
            if (finalY > 250) {
                doc.addPage();
                finalY = 20;
            }

            doc.setFontSize(10);
            doc.setTextColor(73, 80, 87);
            doc.text(`Kargo Firması: ${safeString(shipment.cargoCompany)}`, 14, finalY + 15);
            doc.text(`Takip No: ${safeString(shipment.trackingNumber)}`, 14, finalY + 21);

            doc.setFontSize(11);
            doc.setTextColor(44, 62, 80);
            doc.text(`Toplam Tutar:`, 160, finalY + 15, { align: 'right' });
            doc.setFontSize(12);
            doc.setFont('Roboto', 'normal');
            doc.text(`${subTotal.toFixed(2)} ${order.currency === 'USD' ? '$' : '₺'}`, 200, finalY + 15, { align: 'right' });
        }

        doc.save(`Toplu-Irsaliye-${order.id.substring(0, 6).toUpperCase()}.pdf`);
    } catch (error) {
        console.error("Toplu İrsaliye PDF oluşturulurken hata:", error);
        throw error;
    }
};

export const generateCustomerBarcodePDF = async (order, companyInfo) => {
    try {
        const doc = new jsPDF();
        doc.addFileToVFS('Roboto-Regular.ttf', font);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');

        doc.setFontSize(22);
        doc.setTextColor(44, 62, 80);
        doc.text("KARGO ETİKETİ", 105, 25, { align: 'center' });

        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 40);
        doc.setFontSize(10);
        doc.text(safeString(companyInfo?.address), 14, 48);
        doc.text(`Tel: ${safeString(companyInfo?.phone)}`, 14, 56);

        doc.setFontSize(12);
        const customerCode = companyInfo?.customerCode || '';
        const label = customerCode ? "Gönderici Müşteri Kodu:" : "Sipariş No:";
        const value = customerCode || (order.id ? order.id.substring(0, 8).toUpperCase() : '');
        doc.text(`${label} ${value}`, 14, 70);
        doc.text(`Tarih: ${order.orderDate?.seconds ? new Date(order.orderDate.seconds * 1000).toLocaleDateString() : 'Tarih Yok'}`, 14, 78);

        doc.setFontSize(14);
        doc.setFont('Roboto', 'normal');
        doc.text("MÜŞTERİ BİLGİLERİ", 14, 95);
        doc.setFont('Roboto', 'normal');

        doc.setFontSize(12);
        doc.text(`Adı: ${safeString(order.customerName)}`, 14, 105);
        doc.text(`Telefon: ${safeString(order.customerPhone)}`, 14, 115);
        doc.text(`E-posta: ${safeString(order.customerEmail)}`, 14, 125);
        doc.text(`İl: ${safeString(order.customerCity)}`, 14, 135);
        doc.text(`İlçe: ${safeString(order.customerDistrict)}`, 14, 145);

        const addressLines = doc.splitTextToSize(`Adres: ${safeString(order.customerAddress)}`, 170);
        doc.text(addressLines, 14, 155);

        const filename = `kargo_etiketi_${order.id.substring(0, 6).toUpperCase()}_${safeString(order.customerName, 'musteri')}.pdf`;
        doc.save(filename);
    } catch (error) {
        console.error("Kargo etiketi PDF oluşturulurken hata:", error);
        throw error;
    }
};

// --- FİYAT TEKLİF FORMU PDF ---
export const generatePriceQuotePDF = async (companyInfo, quote, products = []) => {
    try {
        const getProduct = (productId) => products.find(p => p.id === productId);
        const doc = new jsPDF();
        doc.addFileToVFS('Roboto-Regular.ttf', font);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');

        const pdfSettings = companyInfo?.pdfSettings || {};
        const sym = quote.currency === 'USD' ? '$' : quote.currency === 'EUR' ? '€' : '₺';
        const hasImages = products.length > 0 && (quote.lineItems || []).some(item => {
            const product = getProduct(item.productId);
            return product && product.imageUrl;
        });

        // Logo or Company Name
        const logoUrl = companyInfo?.logoUrl || pdfSettings.logoUrl;

        // Logo or Company Name
        if (logoUrl) {
            try {
                const logoData = await imageToDataUrl(logoUrl);
                doc.addImage(logoData, 'JPEG', 14, 12, 35, 15);
            } catch (e) {
                doc.setFontSize(22);
                doc.setTextColor(44, 62, 80);
                doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 22);
            }
        } else {
            doc.setFontSize(22);
            doc.setTextColor(44, 62, 80);
            doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 22);
        }


        // Title
        doc.setFontSize(18);
        doc.setTextColor(102, 126, 234);
        doc.text("FİYAT TEKLİF FORMU", 200, 22, { align: 'right' });
        doc.setDrawColor(102, 126, 234);
        doc.setLineWidth(0.5);
        doc.line(14, 28, 200, 28);

        // Initial Y position for content below header line
        let currentY = 35;

        // --- LEFT SIDE: Company Info ---
        doc.setFontSize(10);
        doc.setTextColor(52, 73, 94);
        doc.setFont("Roboto", "normal");
        doc.text("Firma Bilgileri", 14, currentY);
        currentY += 6;

        doc.setFontSize(9);
        doc.setTextColor(73, 80, 87);
        doc.setFont("Roboto", "normal");

        // Wrap company name
        const wrappedCompanyName = doc.splitTextToSize(safeString(companyInfo?.companyName), 80);
        doc.text(wrappedCompanyName, 14, currentY);
        currentY += wrappedCompanyName.length * 4;

        // Wrap address
        const wrappedAddress = doc.splitTextToSize(safeString(companyInfo?.address), 80);
        doc.text(wrappedAddress, 14, currentY);
        currentY += wrappedAddress.length * 4;

        doc.text(`Tel: ${safeString(companyInfo?.phone)}`, 14, currentY);
        currentY += 5;
        doc.text(`VD: ${safeString(companyInfo?.taxOffice)} / ${safeString(companyInfo?.taxNumber)}`, 14, currentY);

        const companyInfoBottomY = currentY;

        // --- RIGHT SIDE: Quote Info & Customer Info ---
        let rightY = 35;

        // Quote Number & Dates
        doc.setFontSize(10);
        doc.setTextColor(52, 73, 94);
        doc.setFont("Roboto", "normal");
        doc.text("Teklif Bilgileri", 120, rightY);
        rightY += 6;

        doc.setFontSize(9);
        doc.setTextColor(73, 80, 87);
        doc.setFont("Roboto", "normal");
        doc.text(`Teklif No: ${safeString(quote.quoteNumber)}`, 120, rightY);
        rightY += 5;

        const quoteDate = quote.quoteDate?.seconds
            ? new Date(quote.quoteDate.seconds * 1000).toLocaleDateString('tr-TR')
            : '-';
        doc.text(`Tarih: ${quoteDate}`, 120, rightY);
        rightY += 5;

        const validUntil = quote.validUntil?.seconds
            ? new Date(quote.validUntil.seconds * 1000).toLocaleDateString('tr-TR')
            : '-';
        doc.text(`Geçerlilik: ${validUntil}`, 120, rightY);
        rightY += 8;

        // Customer Info
        doc.setFontSize(10);
        doc.setTextColor(52, 73, 94);
        doc.setFont("Roboto", "normal");
        doc.text("Müşteri Bilgileri", 120, rightY);
        rightY += 6;

        doc.setFontSize(9);
        doc.setTextColor(73, 80, 87);
        doc.setFont("Roboto", "normal");

        // Wrap customer name
        const wrappedCustomerName = doc.splitTextToSize(safeString(quote.customerName), 80);
        doc.text(wrappedCustomerName, 120, rightY);
        rightY += wrappedCustomerName.length * 4;

        // Customer Address
        const custAddress = quote.customerAddress || "";
        if (custAddress) {
            const wrappedCustAddress = doc.splitTextToSize(safeString(custAddress), 80);
            doc.text(wrappedCustAddress, 120, rightY);
            rightY += wrappedCustAddress.length * 4;
        }

        // Customer Tax Info
        if (quote.customerTaxOffice || quote.customerTaxNumber) {
            doc.text(`VD: ${safeString(quote.customerTaxOffice)} / ${safeString(quote.customerTaxNumber)}`, 120, rightY);
            rightY += 5;
        }

        // Final Y for start of table
        const finalInfoY = Math.max(companyInfoBottomY, rightY) + 10;

        // Product Table with images
        const tableColumn = hasImages
            ? ["Görsel", "#", "Ürün Adı", "Miktar", "Birim Fiyat", "İskonto", "Toplam"]
            : ["#", "Ürün Adı", "Miktar", "Birim Fiyat", "İskonto", "Toplam"];

        const tableRows = await Promise.all((quote.lineItems || []).map(async (item, index) => {
            const product = getProduct(item.productId);
            let imageData = null;
            if (hasImages && product && product.imageUrl) {
                try { imageData = await imageToDataUrl(product.imageUrl); } catch (e) { console.error("Resim yüklenemedi:", e); }
            }

            let rowData = [];
            if (hasImages) rowData.push(imageData ? { image: imageData, width: 15, height: 15 } : '');
            rowData.push(String(index + 1));
            rowData.push(safeString(item.name));
            rowData.push(safeString(item.quantity));
            rowData.push(`${safeNumber(item.unitPrice).toFixed(2)} ${sym}`);
            rowData.push(item.discount > 0 ? `%${item.discount}` : '-');
            rowData.push(`${safeNumber(item.total).toFixed(2)} ${sym}`);
            return rowData;
        }));

        const colStyles = hasImages
            ? { 0: { cellWidth: 20, minCellHeight: 20 }, 1: { cellWidth: 12 }, 4: { halign: 'right' }, 5: { halign: 'center' }, 6: { halign: 'right' } }
            : { 0: { cellWidth: 12 }, 3: { halign: 'right' }, 4: { halign: 'center' }, 5: { halign: 'right' } };

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: finalInfoY,
            theme: 'striped',
            headStyles: { fillColor: [102, 126, 234] },
            styles: { font: 'Roboto', fontStyle: 'normal', fontSize: 9 },
            columnStyles: colStyles,
            didDrawCell: (data) => {
                if (hasImages && data.column.index === 0 && data.cell.section === 'body' && data.cell.raw?.image) {
                    const img = data.cell.raw.image;
                    try {
                        const imgProps = doc.getImageProperties(img);
                        const imgWidth = 15;
                        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
                        const x = data.cell.x + (data.cell.width - imgWidth) / 2;
                        const y = data.cell.y + (data.cell.height - imgHeight) / 2;
                        doc.addImage(img, 'JPEG', x, y, imgWidth, imgHeight);
                    } catch (e) {
                        console.error("Görsel çizilemedi:", e);
                    }
                }
            }
        });

        let finalY = doc.lastAutoTable.finalY || finalInfoY;
        if (finalY > 220) {
            doc.addPage();
            finalY = 20;
        }

        // Totals
        currentY = finalY + 15;
        doc.setFontSize(10);
        doc.setTextColor(73, 80, 87);

        doc.text("Ara Toplam:", 160, currentY, { align: 'right' });
        doc.text(`${safeNumber(quote.subTotal).toFixed(2)} ${sym}`, 200, currentY, { align: 'right' });
        currentY += 7;

        if (quote.discountRate > 0) {
            doc.text(`Genel İskonto (%${quote.discountRate}):`, 160, currentY, { align: 'right' });
            doc.setTextColor(220, 38, 38);
            doc.text(`-${safeNumber(quote.discountAmount).toFixed(2)} ${sym}`, 200, currentY, { align: 'right' });
            doc.setTextColor(73, 80, 87);
            currentY += 7;
        }

        doc.text(`KDV (%${quote.vatRate || 0}):`, 160, currentY, { align: 'right' });
        doc.text(`${safeNumber(quote.vatAmount).toFixed(2)} ${sym}`, 200, currentY, { align: 'right' });
        currentY += 7;

        doc.setDrawColor(102, 126, 234);
        doc.setLineWidth(0.3);
        doc.line(140, currentY, 200, currentY);
        currentY += 7;

        doc.setFontSize(12);
        doc.setTextColor(5, 150, 105);
        doc.text("GENEL TOPLAM:", 160, currentY, { align: 'right' });
        doc.text(`${safeNumber(quote.total).toFixed(2)} ${sym}`, 200, currentY, { align: 'right' });

        // Notes
        if (quote.notes) {
            currentY += 20;
            doc.setFontSize(10);
            doc.setTextColor(73, 80, 87);
            doc.text("Notlar:", 14, currentY);
            doc.setFontSize(9);
            const noteLines = doc.splitTextToSize(quote.notes, 170);
            doc.text(noteLines, 14, currentY + 7);
        }

        // Save
        const filename = `Teklif-${safeString(quote.quoteNumber, 'TKF')}-${safeString(quote.customerName, 'Musteri').replace(/\s+/g, '-').substring(0, 20)}.pdf`;
        doc.save(filename);
    } catch (error) {
        console.error("Fiyat teklifi PDF oluşturulurken hata:", error);
        throw error;
    }
};
// --- RECONCILIATION PDF generation ---
export const generateReconciliationPDF = async (companyInfo, party, transactions, dateRange = null, lastReconciliationDate = null) => {
    try {
        const doc = new jsPDF();
        doc.addFileToVFS('Roboto-Regular.ttf', font);
        doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
        doc.setFont('Roboto');

        if (!party) throw new Error("Müşteri bilgisi bulunamadı");
        let safeTransactions = transactions || [];

        // CALCULATE MISSING BALANCE (Müşteri gerçel bakiyesi ile sistemin bildiği hareketler arasındaki fark)
        // Excel içe aktarımları, sipariş bazlı bakiye kaymaları veya manuel bakiye güncellemelerini yakalamak için.
        let allKnownRunningBalance = 0;
        safeTransactions.forEach(t => {
            const amount = t.amount || 0;
            let borc = 0;
            let alacak = 0;
            const type = (t.type || '').toLowerCase();
            const isSupplier = party.type === 'tedarikci';

            if (type === 'tahsilat' || type === 'ödeme alındı' || type === 'collection') {
                alacak = amount;
            } else if (type === 'satış' || type === 'sale') {
                borc = amount;
            } else if (type === 'fatura' || type === 'sipariş' || type === 'invoice' || type === 'order') {
                if (isSupplier) alacak = amount; else borc = amount;
            } else if (type === 'ödeme' || type === 'payment') {
                if (isSupplier) borc = amount; else alacak = amount;
            } else if (type === 'iade' || type === 'return') {
                if (isSupplier) borc = amount; else alacak = amount;
            } else if (type === 'return_cancel' || type === 'iade iptali') {
                if (isSupplier) alacak = amount; else borc = amount;
            }
            allKnownRunningBalance += (alacak - borc);
        });

        const actualBalance = party.balance || 0;
        const missingBalance = actualBalance - allKnownRunningBalance;

        if (Math.abs(missingBalance) > 0.01) {
            safeTransactions.unshift({
                date: new Date('2000-01-01T00:00:00Z'),
                description: 'Sistem Açılış / Düzeltme Bakiyesi',
                type: 'Açılış/Devir',
                isMissingBalance: true,
                amount: Math.abs(missingBalance),
                sign: missingBalance > 0 ? 'alacak' : 'borc'
            });
        }

        let devredenBakiye = 0;

        if (dateRange) {
            const start = new Date(dateRange.start);
            const end = new Date(dateRange.end);
            end.setHours(23, 59, 59, 999);
            
            // Calculate Devreden Bakiye from transactions before start date
            safeTransactions.forEach(t => {
                const tDate = t.date?.seconds ? new Date(t.date.seconds * 1000) : new Date(t.date);
                if (tDate < start) {
                    const amount = t.amount || 0;
                    let borc = 0;
                    let alacak = 0;
                    const type = (t.type || '').toLowerCase();
                    const isSupplier = party.type === 'tedarikci';

                    if (t.isMissingBalance) {
                        if (t.sign === 'alacak') alacak = amount;
                        else borc = amount;
                    } else if (type === 'tahsilat' || type === 'ödeme alındı' || type === 'collection') {
                        alacak = amount;
                    } else if (type === 'satış' || type === 'sale') {
                        borc = amount;
                    } else if (type === 'fatura' || type === 'sipariş' || type === 'invoice' || type === 'order') {
                        if (isSupplier) alacak = amount; else borc = amount;
                    } else if (type === 'ödeme' || type === 'payment') {
                        if (isSupplier) borc = amount; else alacak = amount;
                    } else if (type === 'iade' || type === 'return') {
                        if (isSupplier) borc = amount; else alacak = amount;
                    } else if (type === 'return_cancel' || type === 'iade iptali') {
                        if (isSupplier) alacak = amount; else borc = amount;
                    }

                    devredenBakiye += (alacak - borc);
                }
            });

            // Filter transactions for the requested date range
            safeTransactions = safeTransactions.filter(t => {
                const tDate = t.date?.seconds ? new Date(t.date.seconds * 1000) : new Date(t.date);
                return tDate >= start && tDate <= end;
            });
        }

        const primaryColor = [79, 70, 229]; // Indigo-600
        const secondaryColor = [100, 116, 139]; // Slate-500
        const lightBg = [248, 250, 252]; // Slate-50

        // --- HEADER ---
        const pdfSettings = companyInfo?.pdfSettings || {};
        const logoUrl = companyInfo?.logoUrl || pdfSettings.logoUrl;

        if (logoUrl) {
            try {
                const logoData = await imageToDataUrl(logoUrl);
                doc.addImage(logoData, 'JPEG', 14, 12, 40, 18);
            } catch (e) {
                doc.setFontSize(22);
                doc.setTextColor(...primaryColor);
                doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 24);
            }
        } else {
            doc.setFontSize(22);
            doc.setTextColor(...primaryColor);
            doc.text(safeString(companyInfo?.companyName, "Firma Adı"), 14, 24);
        }

        doc.setFontSize(18);
        doc.setTextColor(...secondaryColor);
        doc.text("MUTABAKAT BELGESİ", 200, 24, { align: 'right' });
        
        doc.setDrawColor(...primaryColor);
        doc.setLineWidth(0.5);
        doc.line(14, 32, 200, 32);

        // --- INFO SECTIONS ---
        let currentY = 42;
        
        // Info Box Header labels
        doc.setFontSize(9);
        doc.setTextColor(...primaryColor);
        doc.text("GÖNDERİCİ (BİZ)", 14, currentY);
        doc.text("İLGİLİ TARAF (SİZ)", 110, currentY);
        currentY += 6;

        // Content
        doc.setFontSize(10);
        doc.setTextColor(30, 41, 59); // Slate-800
        
        // Left Side (Us)
        doc.setFont('Roboto', 'normal');
        doc.text(safeString(companyInfo?.companyName), 14, currentY);
        doc.setFontSize(8);
        doc.setTextColor(...secondaryColor);
        const wrappedBizAddr = doc.splitTextToSize(safeString(companyInfo?.address), 80);
        doc.text(wrappedBizAddr, 14, currentY + 5);
        const bizAddrHeight = wrappedBizAddr.length * 4;
        doc.text(`Tel: ${safeString(companyInfo?.phone)}`, 14, currentY + 6 + bizAddrHeight);
        doc.text(`VD: ${safeString(companyInfo?.taxOffice)} / ${safeString(companyInfo?.taxNumber)}`, 14, currentY + 11 + bizAddrHeight);

        // Right Side (Party)
        doc.setFontSize(10);
        doc.setTextColor(30, 41, 59);
        doc.text(safeString(party.name), 110, currentY);
        doc.setFontSize(8);
        doc.setTextColor(...secondaryColor);
        const wrappedPartyAddr = doc.splitTextToSize(safeString(party.address), 85);
        doc.text(wrappedPartyAddr, 110, currentY + 5);
        const partyAddrHeight = wrappedPartyAddr.length * 4;
        const partyTaxInfo = party.taxNumber ? `VD: ${safeString(party.taxOffice)} / ${safeString(party.taxNumber)}` : '';
        if (party.phone) doc.text(`Tel: ${safeString(party.phone)}`, 110, currentY + 6 + partyAddrHeight);
        if (partyTaxInfo) doc.text(partyTaxInfo, 110, currentY + 11 + partyAddrHeight);

        // Period & Date (Floating top right)
        doc.setFontSize(9);
        doc.setTextColor(...primaryColor);
        doc.text("DÖNEM:", 200, currentY, { align: 'right' });
        doc.setTextColor(...secondaryColor);
        const periodText = dateRange ? `${dateRange.start} - ${dateRange.end}` : "Tüm Dönem";
        doc.text(periodText, 200, currentY + 5, { align: 'right' });
        
        doc.setTextColor(...primaryColor);
        doc.text("BELGE TARİHİ:", 200, currentY + 12, { align: 'right' });
        doc.setTextColor(...secondaryColor);
        doc.text(new Date().toLocaleDateString('tr-TR'), 200, currentY + 17, { align: 'right' });

        currentY = Math.max(currentY + 20 + bizAddrHeight, currentY + 20 + partyAddrHeight);

        // --- TABLE ---
        const currencySym = party.currency === 'USD' ? '$' : '₺';
        const tableColumn = ["Tarih", "Vade", "Açıklama", "Tür", "Borç", "Alacak", "Bakiye"];
        let runningBalance = devredenBakiye;
        
        let tableRows = [];

        if (dateRange && devredenBakiye !== 0) {
            tableRows.push([
                `${dateRange.start}`,
                '-',
                'Devreden Bakiye',
                'Devir',
                devredenBakiye < 0 ? Math.abs(devredenBakiye).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) : '-',
                devredenBakiye > 0 ? devredenBakiye.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) : '-',
                runningBalance.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ` ${currencySym}`
            ]);
        }
        
        const contentRows = safeTransactions.map(t => {
            const amount = t.amount || 0;
            let borc = 0;
            let alacak = 0;
            const type = (t.type || '').toLowerCase();
            const isSupplier = party.type === 'tedarikci';

            if (t.isMissingBalance) {
                if (t.sign === 'alacak') alacak = amount;
                else borc = amount;
            } else if (type === 'tahsilat' || type === 'ödeme alındı' || type === 'collection') {
                alacak = amount;
            } else if (type === 'satış' || type === 'sale') {
                borc = amount;
            } else if (type === 'fatura' || type === 'sipariş' || type === 'invoice' || type === 'order') {
                if (isSupplier) alacak = amount; else borc = amount;
            } else if (type === 'ödeme' || type === 'payment') {
                if (isSupplier) borc = amount; else alacak = amount;
            } else if (type === 'iade' || type === 'return') {
                if (isSupplier) borc = amount; else alacak = amount;
            } else if (type === 'return_cancel' || type === 'iade iptali') {
                if (isSupplier) alacak = amount; else borc = amount;
            }

            runningBalance += (alacak - borc);

            return [
                t.date?.seconds ? new Date(t.date.seconds * 1000).toLocaleDateString('tr-TR') : '-',
                t.dueDate ? new Date(t.dueDate).toLocaleDateString('tr-TR') : '-',
                safeString(t.description),
                safeString(t.type),
                borc > 0 ? borc.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) : '-',
                alacak > 0 ? alacak.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) : '-',
                runningBalance.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ` ${currencySym}`
            ];
        });

        tableRows = [...tableRows, ...contentRows];

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: currentY,
            theme: 'striped',
            headStyles: { 
                fillColor: [241, 245, 249], // Slate-100
                textColor: [30, 41, 59], // Slate-800
                halign: 'center', 
                fontSize: 9, 
                lineColor: [226, 232, 240], // Slate-200 lines
                lineWidth: 0.1,
                fontStyle: 'normal',
                cellPadding: 2
            },
            styles: { 
                font: 'Roboto', 
                fontSize: 8,
                cellPadding: 3,
                textColor: [51, 65, 85]
            },
            columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 20 },
                2: { cellWidth: 'auto' },
                3: { cellWidth: 20 },
                4: { halign: 'right', cellWidth: 25 },
                5: { halign: 'right', cellWidth: 25 },
                6: { halign: 'right', cellWidth: 30, fontStyle: 'normal', textColor: [30, 41, 59] }
            }
        });

        let finalY = doc.lastAutoTable.finalY + 15;
        if (finalY > 210) {
            doc.addPage();
            finalY = 25;
        }

        // --- SUMMARY BOX ---
        doc.setFillColor(...lightBg);
        doc.rect(14, finalY, 186, 45, 'F');
        doc.setDrawColor(226, 232, 240);
        doc.rect(14, finalY, 186, 45, 'S');

        doc.setFontSize(11);
        doc.setTextColor(...primaryColor);
        doc.setFont('Roboto', 'normal');
        doc.text("GÜNCEL DURUM ÖZETİ", 20, finalY + 10);

        const totalOrders = safeTransactions.filter(t => ['fatura', 'satış', 'invoice', 'sale', 'sipariş', 'order'].includes((t.type || '').toLowerCase())).reduce((s, t) => s + (t.amount || 0), 0);
        const totalPayments = safeTransactions.filter(t => ['tahsilat', 'ödeme', 'ödeme alındı', 'payment', 'collection'].includes((t.type || '').toLowerCase())).reduce((s, t) => s + (t.amount || 0), 0);
        const totalReturns = safeTransactions.filter(t => ['iade', 'return', 'iade iptali', 'return_cancel'].includes((t.type || '').toLowerCase())).reduce((s, t) => {
            const isCancel = ['iade iptali', 'return_cancel'].includes((t.type || '').toLowerCase());
            return s + (isCancel ? -(t.amount || 0) : (t.amount || 0));
        }, 0);

        let startingBalance = devredenBakiye;
        safeTransactions.forEach(t => {
            if (t.isMissingBalance) {
                let borc = 0, alacak = 0;
                if (t.sign === 'alacak') alacak = t.amount || 0;
                else borc = t.amount || 0;
                startingBalance += (alacak - borc);
            }
        });
        const startIsBorclu = startingBalance < 0;
        const startBalanceText = `${Math.abs(startingBalance).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ${currencySym} (${startIsBorclu ? 'Borç' : 'Alacak'})`;

        doc.setFontSize(9);
        doc.setTextColor(...secondaryColor);
        
        let summaryY = finalY + 20;

        if (Math.abs(startingBalance) > 0.01) {
            doc.text(`Devreden/Açılış Bakiyesi:`, 20, summaryY);
            doc.text(startBalanceText, 85, summaryY, { align: 'right' });
            summaryY += 6;
        }

        doc.text(`Toplam Sipariş/Fatura Tutar:`, 20, summaryY);
        doc.text(`${totalOrders.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ${currencySym}`, 85, summaryY, { align: 'right' });
        summaryY += 6;
        
        doc.text(`Toplam Ödeme/Tahsilat Tutarı:`, 20, summaryY);
        doc.text(`${totalPayments.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ${currencySym}`, 85, summaryY, { align: 'right' });
        summaryY += 6;

        if (totalReturns > 0) {
            doc.text(`Net İade Tutarı:`, 20, summaryY);
            doc.text(`${totalReturns.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ${currencySym}`, 85, summaryY, { align: 'right' });
        }

        // Final Balance Highlight
        const finalBalance = runningBalance;
        const isBorclu = finalBalance < 0;
        const balanceLabel = isBorclu ? "KALAN BORÇ BAKİYESİ" : "KALAN ALACAK BAKİYESİ";
        
        doc.setFontSize(10);
        doc.setTextColor(30, 41, 59);
        doc.setFont('Roboto', 'normal');
        doc.text(balanceLabel, 115, finalY + 20);
        doc.setFontSize(16);
        doc.setTextColor(...(isBorclu ? [220, 38, 38] : [22, 163, 74])); // Red-600 or Green-600
        doc.text(`${Math.abs(finalBalance).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ${currencySym}`, 115, finalY + 32);

        // --- FOOTER / CONFIRMATION ---
        finalY += 55;
        if (finalY > 260) {
            doc.addPage();
            finalY = 25;
        }

        doc.setFontSize(9);
        doc.setTextColor(71, 85, 105);
        doc.text("Yukarıdaki dökümün kayıtlarımızla mutabık olup olmadığını onaylamanızı rica ederiz.", 14, finalY);

        // Signature Boxes
        finalY += 20;
        doc.setDrawColor(203, 213, 225);
        
        // Biz Box
        doc.line(14, finalY + 20, 95, finalY + 20);
        doc.setFontSize(8);
        doc.setTextColor(...secondaryColor);
        doc.text("KAŞE / İMZA (FİRMA)", 14, finalY + 25);
        doc.setFontSize(7);
        doc.text(safeString(companyInfo?.companyName).substring(0, 40), 14, finalY + 29);

        // Siz Box
        doc.line(110, finalY + 20, 191, finalY + 20);
        doc.setFontSize(8);
        doc.text("KAŞE / İMZA (MÜŞTERİ)", 110, finalY + 25);
        doc.setFontSize(7);
        doc.text(safeString(party.name).substring(0, 40), 110, finalY + 29);

        const partyNameSlug = (party.name || 'Mutabakat').replace(/\s+/g, '-');
        const filename = `Mutabakat-${partyNameSlug}-${new Date().toLocaleDateString('tr-TR')}.pdf`;
        doc.save(filename);
        return doc;
    } catch (error) {
        console.error("Mutabakat PDF hatası:", error);
        throw error;
    }
};
